/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExfOfacEmulatorV1OfacEmulatorState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXF_OFAC_EMULATOR_V1_OFAC_EMULATOR_STATE_ENTITY_NAME = 'exf.ofac.emulator.v1.OfacEmulator';
export const exfOfacEmulatorV1OfacEmulatorStateEntity = new schema.Entity<ExfOfacEmulatorV1OfacEmulatorState>(EXF_OFAC_EMULATOR_V1_OFAC_EMULATOR_STATE_ENTITY_NAME, {}, { idAttribute: 'ofacEmulatorId' });

